import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useSetAtom } from 'jotai';
import { simProductsUrlParamsAtom } from 'src/atoms/filters/sim-products';
import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';

export const SimFiltersURLParser = ({ children }: { children: React.ReactNode }) => {
  const [searchParams] = useSearchParams();

  const setURLParams = useSetAtom(simProductsUrlParamsAtom);
  const isMounted = useRef(false);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: simProductsUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setURLParams(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
